{
  "back": "Retour",
  "browserConnect": "Connexion au navigateur",
  "cancel": "Annuler",
  "closeDialog": "Fermer la boîte de dialogue",
  "closeErrorAlert": "Fermer l'alerte d'erreur",
  "closeInfoAlert": "Fermer l'alerte d'information",
  "connect": "Connecter",
  "connectTo": "Connectez-vous à",
  "emailAddress": "Courriel",
  "enabled": "Activé",
  "error400": "Erreur 400 - Notre système indique que la demande du client envoyée à nos serveurs internes est invalide ou corrompue. Veuillez contacter notre équipe d'assistance.",
  "error401": "Erreur 401 - Notre système indique que ce compte n'est pas autorisé à effectuer cette action. Veuillez contacter notre équipe d'assistance.",
  "error500": "Erreur 500 - Nous rencontrons des problèmes avec nos serveurs internes et cette action ne peut pas être effectuée pour le moment. Veuillez réessayer plus tard.",
  "error429": "Trop de demandes - Limite atteinte, veuillez patienter 1 heure avant de réessayer",
  "errorFound": "Erreur détectée",
  "errorsFound": "Erreurs détectées",
  "missingDetailsError": "Veuillez fournir les détails manquants.",
  "next": "Suivant",
  "no": "Non",
  "none": "Aucun",
  "off": "Arrêt",
  "on": "Marche",
  "other": "Autre",
  "password": "Mot de passe",
  "pleaseEnterDetails": "Veuillez saisir les informations suivantes…",
  "pleaseSpecify": "Veuillez préciser",
  "readOnly": "Lecture seule",
  "required": "obligatoire",
  "requiredFieldError": "Ce champ est requis.",
  "requiredFields": "Un astérisque * indique que quelque chose est nécessaire",
  "save": "Enregistrer",
  "selectAllApply": "Sélectionnez tout ce qui s'applique",
  "selectOneError": "Sélectionnez au moins une option.",
  "submit": "Soumettre",
  "userName": "Nom d'utilisateur",
  "validEmailAddress": "Une adresse courriel valide est requise.",
  "validValueError": "Sélectionner une valeur valide.",
  "vmOpensInANewWindow": "La machine virtuelle s'ouvrira dans une nouvelle fenêtre",
  "workEmail": "Courriel professionnel ",
  "yes": "Oui",
  "maxLengthField": "La valeur ne doit pas dépasser {{fieldLimit}} caractères.",
  "helpSupportHeading": "Communiquez avec notre équipe de soutien dédiée",
  "helpSupportParagraph": "Pour toute question d'ordre général ou pour nous faire part de vos commentaires, veuillez communiquer avec notre équipe de soutien. Un membre de l'équipe se fera un plaisir de vous aider.",
  "helpSupportButton": "Communiquer avec notre équipe de soutien",
  "helpTrainingHeading": "Ressources de formation",
  "helpTrainingParagraph1": "Le guide de formation sur Azure a été conçu pour vous aider à naviguer et à mieux comprendre les cours et certifications auxquels vous avez accès dans le portail",
  "helpTrainingUrl": "https://esi.microsoft.com/",
  "helpTrainingLink": "Enterprise Skills Initiative",
  "helpTrainingParagraph2": "de Microsoft.",
  "helpTrainingButtonHref": "https://github.com/StatCan/cae-eac/raw/master/docs/fr/Parcours%20d_apprentissage%20bas%C3%A9%20sur%20les%20roles.pdf",
  "helpTrainingButton": "Guide de formation sur Azure (PDF, 1.3 MB)",
  "helpAAWParagraph": "Veuillez consulter le guide de l'utilisateur de l'espace de travail d'analyse avancée (ETAA) ci dessous si vous éprouvez des difficultés à l'égard de composantes du système ou d'outils propres à l'ETAA. Pour toute préoccupation ou question d'ordre général, veuillez communiquer avec l'équipe de soutien. Un membre de l'équipe des SAD se fera un plaisir de vous aider.",
  "helpAAWButton": "Guide de l'utilisateur de l'ETAA",
  "helpCAEParagraph": "Veuillez consulter le guide de l'utilisateur de l'environnement d'analyse collaboratif (EAC) ci dessous si vous éprouvez des difficultés à l'égard de composantes du système ou d'outils propres à l'EAC. Pour toute préoccupation ou question d'ordre général, veuillez communiquer avec l'équipe de soutien. Un membre de l'équipe des SAD se fera un plaisir de vous aider.",
  "helpCAEButton": "Guide de l'utilisateur de l'EAC",
  "helpGAEParagraph": "Veuillez consulter le guide de l'utilisateur de l'environnement d'analyse géospatiale (EAG) ci dessous si vous éprouvez des difficultés à l'égard de composantes du système ou d'outils propres à l'EAG. Pour toute préoccupation ou question d'ordre général, veuillez communiquer avec l'équipe de soutien. Un membre de l'équipe des SAD se fera un plaisir de vous aider.",
  "helpGAEButton": "Guide de l'utilisateur de l'EAG",
  "supportHeading": "Communiquer avec l'équipe de soutien",
  "supportCategoryLabel": "Aidez nous à diriger votre demande de soutien aux personnes appropriées. Sélectionnez la catégorie qui correspond le mieux à votre demande de soutien. ",
  "supportCategoryAccount": "Se connecter",
  "supportCategoryAAW": "Plateforme ou outils de l'ETAA",
  "supportCategoryCAE": "Plateforme ou outils de l'EAC",
  "supportCategoryGAE": "Plateforme ou outils de l'EAG",
  "supportQuestionLabel": "Comment pouvons-nous vous aider? ",
  "feedbackQuestionLabel": "Quel message souhaitez-vous nous transmettre? ",
  "feedbackRatingLabel": "Comment avez-vous trouvé votre expérience d'utilisation de ce portail? ",
  "feedbackRatingPositive": "Positive",
  "feedbackRatingNeutral": "Neutre",
  "feedbackRatingNegative": "Négative",
  "getStartedBanner": "Lorsqu'un de nos représentants aura examiné cette demande, nous vous contacterons pour discuter des prochaines étapes du processus.",
  "accountHeading": "Étape 1 de 3",
  "accountDescription": "Pour démarrer ce processus, nous avons besoin de quelques informations vous concernant. Veuillez entrer les informations requises ci-dessous.",
  "accountFirstName": "Prénom ",
  "accountLastName": "Nom de famille ",
  "accountOrganization": "Organisme ",
  "accountJobTitle": "Titre du poste ",
  "accountTypeHeading": "Étape 2 de 3",
  "accountTypeBackButton": "Retour à l'étape 1",
  "accountTypeLabel": "Comment pouvons-nous vous aider à démarrer avec notre service? *",
  "accountTypeDesc": "Nous proposons quelques options pour commencer. Vous pouvez essayer notre service et explorer ce que nous proposons et/ou démarrer un nouveau projet si vous savez ce dont vous avez besoin.",
  "accountTypeTryService": "Essayez notre service et découvrez ce que nous proposons.",
  "accountTypeNewProject": "Commencer un nouveau projet.",
  "registerHeading": "Étape 3 de 3",
  "registerBackButton": "Retour à l'étape 2",
  "registerAgree": "J'accepte les",
  "registerTerms": "conditions générales",
  "registerAnd": "et la ",
  "registerPrivacy": "politique de confidentialité",
  "registerResearch": "J'aimerais participer à des activités de recherche futures pour aider Statistique Canada à améliorer ses outils et ses services.",
  "successHeading": "Succès",
  "successMessage": "Les renseignements fournis ont été envoyés avec succès.",
  "successWillContactMessage": "Notre équipe vous contactera dans un délai de deux semaines.",
  "kubeflowRequestNameSpaceTitle": "Demander un espace de nommage Kubeflow",
  "kubeflowRequestNameSpaceAfterSubmit": "Après avoir soumis la demande d'espace de nommage Kubeflow, un administrateur communiquera avec vous pour vous poser des questions ou faire des mises à jour.",
  "kubeflowRequestNameSpaceNameFormat": "Veuillez créer un nom qui respecte le format suivant : « division-section-projet ».",
  "kubeflowRequestNameSpaceLabel": "Nom de l'espace de nommage",
  "kubeflowRequestNameSpaceSubmit": "Transmettre la demande",
  "kubeflowRequestNameSpaceInvalidChars": "Le nom ne peut contenir que les caractères suivants : « a-z » (en minuscules); « 0-9 »; « - »; « . ».",
  "kubeflowRequestNameSpaceInvalidFirstChar": "Le nom doit commencer par l'un des caractères suivants : « a-z » ou « 0-9 ».",
  "kubeflowRequestNameSpaceInvalidLastChar": "Le nom doit se terminer par l'un des caractères suivants : « a-z » ou « 0-9 ».",
  "alertStartedTitle": "Avant de commencer",
  "alertSignInTitle": "Inscription à la version bêta ",
  "alertSignIn": "L'ouverture d'une session vous donne la possibilité de :",
  "alertSignInIntroText": "Vous devez avoir ouvert une session avec votre compte de Statistique Canada pour commencer un formulaire de demande de projet.",
  "alertSignInBullet1": "soumettre des demandes de projet ",
  "alertSignInBullet2": "faire des demandes d'espace de noms pour Kubeflow. ",
  "alertSignInAzureAccount": "Vous n'avez pas de compte associé à Statistique Canada?",
  "alertSignInBetaLink": "Inscrivez-vous à la version bêta ",
  "alertSignInBeta": "Que voulez-vous essayer avec les Services d'analyse des données? ",
  "alertSignInSuccess": "Merci de vous être inscrit à la version bêta! ",
  "alertSignInText": "Les prochaines étapes et des renseignements supplémentaires vous seront envoyés par courriel à l'adresse que vous avez fournie.",
  "alertDas": "Propulsés par Statistique Canada",
  "forgotPasswordHeading": "Confirmer la réinitialisation du mot de passe",
  "forgotPasswordFirstParagraph": "Voulez-vous vraiment lancer le processus de réinitialisation du mot de passe?",
  "forgotPasswordSecondParagraph": "Cette opération enverra une demande à l'équipe de soutien, qui vous informera des prochaines étapes. La réinitialisation du mot de passe peut prendre environ deux jours ouvrables.",
  "successForgotPasswordMessage": "Le processus de réinitialisation du mot de passe a été lancé. Veuillez attendre que l'équipe de soutien communique avec vous.",
  "vmAmPm": "[N/A to French page]",
  "vmAutoShutdownSettingsFor": "Paramètres d'arrêt automatique pour",
  "vmEmailAddressForNotifications": "Adresse électronique pour les notifications",
  "vmHour": "Heure",
  "vmMinute": "Minute",
  "vmNotificationMinutesBeforeShutdown": "Minutes d'avis avant l'arrêt automatique",
  "vmScheduledShutdown": "Arrêt programmé",
  "vmSendNotificationBeforeAutoShutdown": "Envoyer une notification avant l'arrêt automatique?",
  "vmTimeZone": "Fuseau horaire",
  "timezonePacific": "(UTC-08:00) heure du Pacifique",
  "timezoneMountain": "(UTC-07:00) heure des Rocheuses",
  "timezoneCentral": "(UTC-06:00) heure du Centre",
  "timezoneEastern": "(UTC-05:00) heure de l'Est",
  "timezoneAtlantic": "(UTC-04:00) heure de l'Atlantique",
  "timezoneNewfoundland": "(UTC-03:30) heure de Terre-Neuve",
  "noChangesMessage": "Il n'y a pas de modifications à enregistrer.",
  "warning": "Avertissement",
  "autoShutdownEnabled": "Arrêt automatique enregistré",
  "sessionExpiredMessage": "Votre session de connexion précédente a expiré. Vous allez maintenant être déconnecté.",
  "redirectedMessage": "La page qui précède ne peut être consultée qu'une fois que vous avez ouvert une session."
}
